import { DocumentApi } from './documentApi';

const documentApi = new DocumentApi();

export { documentApi };
